import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {SessionActions} from "../../actions/session.actions";
import {NgRedux} from "@angular-redux/store";
import {Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {IAppState} from "../../redux-store/store";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";

@Component({
  selector: 'vb-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent extends AbstractVisbosComponent implements OnInit, OnDestroy {

  loginForm: FormGroup;


  constructor(sessionActions: SessionActions,
              private router: Router,
              private fb: FormBuilder,
              private ngRedux: NgRedux<IAppState>, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();

    this.loginForm = this.fb.group({
      'email': [null, Validators.compose([Validators.required, Validators.email])],
      'password': [null, Validators.required],
    });

  }

  onSubmit(credentials) {
    this.dataSubscriptions.push(this.sessionActions.loginUser(credentials.email, credentials.password)
      .subscribe((user: any) => this.redirectToHome()));
  }

  redirectToHome() {

    let url = '';

    if (this.currentUser.roles.find(str => str == "touch-client")) {
      url = '/touch';
    } else {
      let redirectUrl = this.ngRedux.getState().session.redirectUrl;
      url = redirectUrl && redirectUrl != "/login" ? redirectUrl : '';
    }

    // Navigate by URL not possible, because store is not loaded fast enough
    this.router.navigate([url]);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/auth/login/login.component.ts